import React, { useState, useEffect } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Element from './element';
import utils from './utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const View = (props) => {
  let [tabs, setTabs] = useState([]);
  let [tab, setTab] = useState({});
  let [pedido, setPedido] = useState({});
  let [processo, setProcesso] = useState({});
  let [view, setView] = useState(props.view ? props.view : {});
  let [ready, setReady] = useState(false);
  let [loading, setLoading] = useState(false);
  let [showMenu, setShowMenu] = useState(false);
  let home = { label: '', view: 'home', key: 'home', icon: 'fa fa-list', menu: true, visible: false };
  let user = utils.getUser();
  let [dialog, setDialog] = useState({});
  let [message, setMessage] = useState({});
  let [title, setTitle] = useState({});
  let [actions, setActions] = useState([]);
  let [dialogOpen, setDialogOpen] = useState(false);
  let [idiomas, setIdiomas] = useState([]);
  let [clients, setClients] = useState([]);
  let [idioma, setIdioma] = useState({});
  let [totalNotificacao, setTotalNotificacao] = useState(0);
  let path = props.path;
  let onReady = props.onReady;
  let [crud, setCrud] = useState({ showMenu: false });
  let [mobile, setMobile] = useState(false);
  let [filial, setFilial] = useState(user.filial);
  let [showDialog, setShowDialog] = useState(false);
  let [filialEdit, setfilialEdit] = useState(false);
  let [popup, setpopup] = useState({});
  let [ispopup, setispopup] = useState(false);

  if (!path) {
    path = window.location.pathname;
  }

  dialog.alert = function (message, title, actions) {
    if (!actions) {
      actions = [];
    }

    if (!title) {
      title = utils.lng('atencao', 'Atenção');
    }
    const translatedMessage = typeof message === 'string' ? utils.lng(message, message) : message;
    setTitle(title);
    setMessage(translatedMessage);
    setActions(actions);
    setDialogOpen(true);
  };

  const actClick = function (act) {
    act.action.call(this);
    setDialogOpen(false);
  };

  dialog.close = function () {
    setDialogOpen(false);

    if (actions.length == 1) {
      actions.forEach((ac) => {
        ac.action.call(this);
      });
    }
  };

  window.dialog = dialog;

  const name = props.name;

  window.idioma = idioma;

  const selecionarCliente = function (i) {
    if (i) {
      let _ks_ = {};
      _ks_.complete = function (res) {
        if (res && res.data) {
          let usr = res.data;
          localStorage.setItem('user', JSON.stringify(usr));
        }
        window.location.reload();
      };
      _ks_.cfg = {
        url: 'client/change/' + i.id,
        method: 'PUT',
        global: false,
      };
      utils.call(_ks_);
    }
  };

  const selecionarIdioma = function (i) {
    if (i) {
      let _ks_ = {};
      _ks_.complete = function (res) {
        if (res && res.data) {
          let usr = res.data;
          localStorage.setItem('user', JSON.stringify(usr));
        }
        window.location.reload();
      };
      _ks_.cfg = {
        url: 'language/change/' + i.id,
        method: 'PUT',
        global: false,
      };
      utils.call(_ks_);
    }
  };

  tabs = utils.getTabs();

  if (tabs) {
    for (const ti in tabs) {
      const ta = tabs[ti];
      let cp = ta.view;

      if (cp === path || cp === path + '/' || cp + '/' === path) {
        tab = ta;
      }
    }
  }

  if (!tab || !tab.key) {
    tab = utils.getTab();
  }

  if (!tab) {
    tab = home;
  }

  view.updateTab = function (cfg) {
    if (cfg) {
      for (const i in cfg) {
        tab[i] = cfg[i];
      }
      tab.refresh = true;
      utils.addTab(tab);
      tabs = utils.getTabs();
      window.tab = utils.getTab();

      setTabs(tabs);
    }
  };

  tabs = utils.getTabs();

  const filialDialog = {
    elements: {
      detail: {
        center: true,
        elements: {
          title: {
            value: utils.lng(
              'label_pergunta_retirar_produto_filial',
              'Por favor, selecione a unidade que deseja acessar.',
            ),
          },
        },
      },
      filialRet: {
        name: 'filialRetirada',
        label: utils.lng('filial_retirada', 'Filial retirada'),
        type: 'select',
        itemValue: 'id',
        itemLabel: 'nome',
        list: {
          url: 'Filial',
        },
      },
      label: {
        center: true,
        elements: {
          info: {
            rendered: utils.getPaisUser() !== 'BRA',
            value: utils.lng(
              'label_aviso_troca_pais',
              'Para comprar em uma filial de outro país, favor alterar o país na bandeirinha do menu',
            ),
          },
        },
      },
    },
  };

  const changeFilial = function () {
    showDialog = true;
    setShowDialog(true);
  };

  const closeDialog = function (isRedirectHome) {
    showDialog = false;
    setShowDialog(false);

    if (isRedirectHome === true) {
      window.location.href = '/home';
    }
  };

  const fecharAbas = function () {
    window.localStorage.removeItem('tabs');
    window.location.href = '/home';
  };

  const logout = function () {
    const actions = [];

    actions.push({
      label: utils.lng('cancelar', 'Cancelar'),
      action: function () { },
    });

    actions.push({
      label: utils.lng('confirmar', 'Confirmar'),
      action: function () {
        localStorage.clear();
        window.location.reload();
      },
    });

    dialog.alert(utils.lng('deseja_realmente_sair', 'Deseja realmente sair?'), null, actions);
  };

  const label = function (l) {
    if (l) {
      l = l.trim();
      l = l.substr(0, 1).toUpperCase() + l.substr(1).toLowerCase();
    }
    return l;
  };

  crud.menuClick = function (cfg, args) {
    const _data_ = args.data;

    delete _data_.id;

    if (_data_.entity || _data_.path) {
      utils.open(args.data);
    } else {
      window.location.href = '/home?superior=' + _data_.id_processo;
    }
  };

  view.open = function (cfg, args) {
    const d = args.data;

    if (d.view) {
      utils.open(d);
    } else if (!d.path) {
      const a = {};
      const e = args.entity ? args.entity : d.entity;
      const id = d.id;

      a.id = id;
      a.entity = e;
      a.id_processo = tab.id_processo;

      if (id >= 0) {
        const l = ['login', 'nome', 'descricao', 'chave', 'titulo'];

        for (const i in l) {
          const v = l[i];
          const o = {};

          o.name = v;
          o.field = v;

          const x = utils.resolve(o, d);

          if (x) {
            a.label = x;
          }
        }
        a.path = '/crud/' + e + '/' + id;
      } else {
        a.path = '/crud/' + e;
      }
      utils.open(a);
    } else {
      utils.open(d);
    }
  };

  const close = function (t) {
    return utils.close(t);
  };

  view.refresh = function () {
    tabs = utils.getTabs();

    setTabs(tabs);
  };

  view.close = function (element, args) {
    let tab = utils.getTab();

    if (!tab || !tab.key) {
      tab = window.tab;
    }
    return utils.close(tab);
  };

  view.loadingStart = function () {
    setLoading(true);
  };

  view.loadingEnd = function () {
    setLoading(false);
  };

  window.view = view;

  const lateral = {
    name: 'lateral_menu_container',
    elements: {
      menu_overlay: {
        type: 'link',
        rendered: '${crud.showMenu === true}',
        click: {
          action: 'hideMenu',
        },
      },
      menu_lateral: {
        type: 'list',
        styleClass: 'menu-lateral',
        header: false,
        size: 1000,
        search: false,
        controls: false,
        click: {
          action: 'menuClick',
        },
        columns: {
          icon: { type: 'icon' },
          label: {},
        },
        list: {
          url: 'listarMenuPrincipal',
        },
      },
    },
  };

  const cookie = {
    name: 'cookie',
    elements: {
      overlay: {},
      left: {
        type: 'span',
        value:
          'A plataforma <b>Interpenn</b> utiliza cookies para controle de sessão.<br> Ao continuar você esta de acordo com o uso de cookies.',
      },
      right: {
        elements: {
          recusar: {
            space: 6,
            label: 'Recusar',
            type: 'button',
            click: {
              prompt: 'Ao recusar da política de cookies, você será desconectado da plataforma.',
              action: 'logout',
            },
          },
          aceitar: {
            space: 6,
            label: 'Aceitar',
            type: 'button',
            click: {
              url: 'salvarConfiguracaoUsuario',
              method: 'POST',
              redirect: true,
              alert: false,
              send: {
                chave: 'salvar_cookies',
                valor: 'true',
              },
              store: {
                salvar_cookies: 'valor',
              },
            },
          },
        },
      },
    },
  };

  const onClick = function (t) {
    const a = {};

    a.data = t;

    view.open(null, a);
  };

  crud.data = {};
  crud.changed = {};

  crud.refresh = function () {
    //faz nada
  };

  let exibirMsgCookie = user.id > 0;
  let x = localStorage.getItem('salvar_cookies');

  if (typeof user.salvar_cookies !== 'undefined') {
    exibirMsgCookie = !eval(user.salvar_cookies);
  } else if (typeof x !== 'undefined' && x != null) {
    exibirMsgCookie = !eval(x);
  }

  const mostraMenu = function () {
    setShowMenu(true);
    crud.showMenu = true;
    setCrud(crud);
  };

  let menuClass = 'menu-left bg-theme ';

  if (showMenu) {
    menuClass += ' menu-show ';
  }

  if (!ready) {
    setReady(true);

    const onCheck = function () {
      if (user && user.id > 0) {
        utils.execute(view, 'listarPopUps', null, function (res) {
          for (const i of res.data) {
            if (i.link_conteudo === window.location.href) {
              var isView = localStorage.getItem(i.imagem);
              if (!isView) {
                setpopup(i);
                setTimeout(() => {
                  setispopup(true);
                }, 2000);
                localStorage.setItem(i.imagem, true);
              }
            }
          }
        });

        if (!props.public) {
          utils.execute(
            view,
            'encontrarPedido?id_pedido=0',
            null,
            function (res) {
              for (const i in res.data) {
                setPedido(res.data[i]);
              }
            },
            false,
          );

          utils.execute(
            view,
            'listarNotificacoes?list=false',
            null,
            function (res) {
              setTotalNotificacao(res.total);
            },
            false,
          );
        }

        utils.execute(view, 'Idioma?ativo=true&sortBy=descricao&sortType=asc', null, function (res) {
          const d = res.data;

          setIdiomas(d);
        });

        utils.execute(view, 'list_clients_by_user', null, function (res) {
          const d = res.data;

          setClients(d);
        });
      }
    };

    if (path === '/' && tab.view) {
      path = tab.view;
    }

    if (!props.public) {
      utils.execute(
        view,
        'check?url=' + path,
        null,
        function (res) {
          if (res.data) {
            let d = res.data;

            window.config = d;
            window.dicionario = d.dictionary;
            window.dictionary = d.dictionary;

            localStorage.setItem('window_dictionary', JSON.stringify(window.dicionario));

            if (d.language) {
              idioma = d.language;
              setIdioma(d.language);
            }

            processo = d;

            if (d.id_processo > 0) {
              let access = d.access;

              delete d.access;

              window.access = access;

              processo.refresh = false;

              utils.addTab(processo);

              if (view.onCheck) {
                view.onCheck(access);
              }
            }

            if (onReady) {
              onReady(d);
            }
            onCheck();
            setProcesso(d);
          }

          window.processo = processo;
        },
        false,
      );
    }
  }

  crud.hideMenu = function () {
    setShowMenu(false);
    crud.showMenu = false;
  };

  const resize = function () {
    mobile = window.innerWidth <= 990;
    setMobile(mobile);
    window.mobile = mobile;
  };

  const labelFilial = function () {
    let path = window.location.pathname;

    if (pedido && pedido.filial && path && path.indexOf('/carrinho') >= 0) {
      if (window.access)
        if (window.access['EDITAR_FILIAL'] === false) {
          return pedido.filial;
        } else {
          return pedido.filial + ' - ' + utils.lng('alterar', 'ALTERAR');
        }
      return pedido.filial + ' - ' + utils.lng('alterar', 'ALTERAR');
    }
    return filial;
  };

  const confirmDialog = function () {
    let _ks_ = {};

    _ks_.cfg = {
      redirect: './carrinho',
      url: 'cart/cancel',
      method: 'POST',
      global: false,
    };
    utils.call(_ks_);

    setInterval(function () {
      var classDialog = document.getElementsByClassName('MuiDialog-root')[0];
      if (classDialog) {
        classDialog.style.display = 'none';
        window.location.replace('/carrinho');
      }
    }, 10);
  };

  const confirmDialogFilial = function () {
    let _ks_ = {};
    _ks_.global = true;

    _ks_.complete = function ({ data }) {
      if (data?.id > 0) {
        localStorage.setItem('user', JSON.stringify(data));
      }
      closeDialog();
    };

    _ks_.cfg = {
      redirect: true,
      url: 'filial/change/' + pedido.filialRetirada.id,
      method: 'PUT',
      global: true,
    };

    utils.call(_ks_);
  };

  useEffect(() => {
    window.addEventListener('resize', resize.bind(this));

    const appPushToken = localStorage.getItem('app_push_token');
    const saveToken = function (currentToken) {
      let saved = window.localStorage.getItem('push_token') + '';

      if (saved !== currentToken) {
        let _ks_ = {};

        _ks_.cfg = {
          url: 'push/registry',
          method: 'POST',
          send: {
            token: currentToken,
          },
          complete: function (res) {
            if (res && res.data && res.data.token) {
              window.localStorage.setItem('push_token', res.data.token);
            }
          },
          global: false,
        };
        utils.call(_ks_);
      }
    };

    try {
      if (appPushToken) {
        saveToken(appPushToken);
      } else {
        const messaging = getMessaging();

        onMessage(messaging, (payload) => {
          console.log(payload);
        });

        getToken(messaging, {
          vapidKey: 'BN1u2vJ7HJncHyPkTZMdc5tc5kUUOrjMTz0rt9G3toRdH7vhW0cuHzRwZe5mIJJSSn0rxvbNlb1awVeRHgb8z7Q',
        })
          .then((currentToken) => {
            if (currentToken) {
              saveToken(currentToken);
            } else {
            }
          })
          .catch((err) => { });
      }
    } catch (error) { }

    resize();
    EditFilialSet();
  }, []);

  const EditFilialSet = function () {
    setInterval(function () {
      if (path.startsWith('/carrinho'))
        if (window.access)
          if (window.access['EDITAR_FILIAL'] === false) {
            setfilialEdit(false);
          } else {
            setfilialEdit(true);
          }
    }, 10);
  };

  const NavIdiomaV2 = () => {
    return (
      <NavDropdown
        title={
          <>
            {idioma?.id > 0 && (
              <div className="ui-idioma-v2-trigger">
                {idioma?.icone && (
                  <img
                    src={idioma.icone}
                    alt={utils.nvl(idioma.legenda, idioma.descricao)}
                    style={{ marginRight: '4px', height: '22px', width: '30px', objectFit: 'contain' }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                {utils.lng('idioma', 'Alterar idioma')}
                <p>{utils.nvl(idioma.legenda, idioma.descricao)}</p>
                <i style={{ color: 'black', marginLeft: '10px' }} className="fas fa-caret-down"></i>
              </div>
            )}
          </>
        }
        id="drop-idiomas"
        className="dropdown-menu-right ui-idioma-select ui-idioma-select-v2 dropdown-menu-lateral"
      >
        {idiomas.map((i) => (
          <NavDropdown.Item
            onClick={() => {
              selecionarIdioma(i);
            }}
            className={'ui-idioma ' + (i.id === idioma.id ? 'ui-item-select selected-idioma ' : '')}
          >
            <div className="ui-idioma-item">
              {i?.icone && (
                <img
                  src={i.icone}
                  alt={i.descricao}
                  style={{ marginRight: '4px', height: '22px', width: '30px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
              <div className="ui-idioma-label">{i.descricao}</div>
            </div>
          </NavDropdown.Item>
        ))}
      </NavDropdown>
    );
  };

  const NavClientsSimple = () => {
    let cliId = user?.cliente?.id;
    let fils = clients.filter((f) => {
      return f.id_cliente === cliId;
    });

    let sel = fils?.[0];

    return (
      <NavDropdown
        title={
          <>
            {sel && sel.id > 0 && (
              <div className="ui-idioma-v2-trigger">
                {sel?.avatar && (
                  <img
                    src={sel.avatar}
                    alt={sel.pais_label}
                    style={{ marginRight: '4px', height: '22px', width: '30px', objectFit: 'contain' }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                <p>{sel.pais_label}</p>
              </div>
            )}
          </>
        }
        id="drop-clientes"
        className={`dropdown-menu-right ui-clients-select-v2 ui-idioma-select-simple dropdown-menu-lateral-simple ${clients.length <= 1 ? 'ui-nav-client-hidden' : ''}`}
      >
        {clients.map((i) => (
          <NavDropdown.Item
            onClick={() => {
              selecionarCliente(i);
            }}
            className={'ui-idioma ' + (i.id_cliente === cliId ? 'ui-item-select selected-idioma' : '')}
          >
            <div className="ui-idioma-item">
              {i?.avatar && (
                <img
                  src={i.avatar}
                  alt={i.pais_label}
                  style={{ marginRight: '4px', height: '22px', width: '30px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
              <div className="ui-idioma-label">{i.pais_label}</div>
            </div>
          </NavDropdown.Item>
        ))}
      </NavDropdown>
    );
  };

  const NavClientsV2 = () => {
    let cliId = user?.cliente?.id;
    let fils = clients.filter((f) => {
      return f.id_cliente === cliId;
    });

    let sel = fils?.[0];

    return (
      <NavDropdown
        title={
          <>
            {sel && sel.id > 0 && (
              <div className="ui-idioma-flag">
                {sel?.avatar && (
                  <img
                    src={sel.avatar}
                    alt={sel.pais_label}
                    style={{ marginRight: '4px', height: '22px', width: '30px', objectFit: 'contain' }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                {utils.lng('alterar_pais', 'Alterar país')}
                <i style={{ color: 'black', marginLeft: '10px' }} className="fas fa-caret-down"></i>
              </div>
            )}
          </>
        }
        id="drop-clientes"
        className={`dropdown-menu-right ui-clients-select-v2 dropdown-menu-lateral ${clients.length <= 1 ? 'ui-nav-client-hidden' : ''}`}
      >
        {clients.map((i) => (
          <NavDropdown.Item
            onClick={() => {
              selecionarCliente(i);
            }}
            className={'ui-idioma ' + (i.id_cliente === cliId ? 'ui-item-select selected-idioma' : '')}
          >
            <div className="ui-idioma-item">
              {i?.avatar && (
                <img
                  src={i.avatar}
                  alt={i.pais_label}
                  style={{ marginRight: '4px', height: '22px', width: '30px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
              <div className="ui-idioma-label">{i.pais_label}</div>
            </div>
          </NavDropdown.Item>
        ))}
      </NavDropdown>
    );
  };

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (document && isIOS) {
    document.documentElement.classList.add('ios');
  }

  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={dialog.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            ></div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {actions.length <= 0 && (
            <Button onClick={dialog.close} color="primary">
              {utils.lng('fechar', 'FECHAR')}
            </Button>
          )}
          {actions.length > 0 && (
            <>
              {actions.map((ac, i) => (
                <Button
                  key={'dlg-act-' + i}
                  variant="contained"
                  onClick={() => {
                    actClick(ac);
                  }}
                  color="primary"
                >
                  {ac.label}
                </Button>
              ))}
            </>
          )}
        </DialogActions>
      </Dialog>
      {props.full !== true && (
        <>
          <header>
            <Navbar bg="white" variant="light" expand="lg" fixed="top">
              <Navbar.Toggle onClick={mostraMenu} aria-controls="basic-navbar-nav" />
              <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ display: 'none' }} />

              {mobile && (
                <div className="navbar-brand-mobile">
                  <NavClientsSimple />
                  {(utils.lng('url-instagram', '') ||
                    utils.lng('url-facebook', '') ||
                    utils.lng('url-youtube', '') ||
                    utils.lng('url-website', '')) && (
                      <NavDropdown
                        id="social-midia-nav-dropdown"
                        title={
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            style={{ marginBottom: 4 }}
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3625 2 11.9875C2 10.6125 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6375 2 12.0125 2C13.3875 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6125 22 11.9875C22 13.3625 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3875 22 12.0125 22C10.6375 22 9.34167 21.7375 8.125 21.2125ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
                              fill="#0a4c96"
                            />
                          </svg>
                        }
                      >
                        {utils.lng('url-instagram', '') && (
                          <>
                            <NavDropdown.Item href={utils.lng('url-instagram', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.9996 2.17468C9.28356 2.17468 8.94335 2.18617 7.87669 2.23505C6.81195 2.28392 6.08551 2.45261 5.44916 2.69986C4.79172 2.95574 4.23396 3.29788 3.67811 3.85373C3.12226 4.40958 2.7801 4.96734 2.52518 5.62478C2.27792 6.26113 2.10833 6.98757 2.06041 8.05231C2.01154 9.11896 2 9.45918 2 12.1752C2 14.8912 2.01154 15.2314 2.06041 16.298C2.10833 17.3628 2.27792 18.0892 2.52518 18.7255C2.7801 19.383 3.12226 19.9407 3.67811 20.4966C4.23396 21.0524 4.79172 21.3946 5.44916 21.6505C6.08551 21.8968 6.81195 22.0664 7.87669 22.1153C8.94335 22.1632 9.28356 22.1747 11.9996 22.1747C14.7155 22.1747 15.0558 22.1632 16.1224 22.1153C17.1872 22.0664 17.9136 21.8968 18.5499 21.6505C19.2073 21.3946 19.7651 21.0524 20.321 20.4966C20.8768 19.9407 21.2189 19.383 21.4748 18.7255C21.7221 18.0892 21.8908 17.3628 21.9396 16.298C21.9885 15.2314 22 14.8912 22 12.1752C22 9.45918 21.9885 9.11896 21.9396 8.05231C21.8908 6.98757 21.7221 6.26113 21.4748 5.62478C21.2189 4.96734 20.8768 4.40958 20.321 3.85373C19.7651 3.29788 19.2073 2.95574 18.5499 2.69986C17.9136 2.45261 17.1872 2.28392 16.1224 2.23505C15.0558 2.18617 14.7155 2.17468 11.9996 2.17468ZM11.9996 3.9764C14.6705 3.9764 14.9858 3.98693 16.0409 4.03485C17.0156 4.07989 17.5456 4.24282 17.8973 4.37987C18.364 4.561 18.6975 4.77759 19.0473 5.12739C19.3971 5.4772 19.6137 5.8107 19.7948 6.27743C19.9319 6.6301 20.0948 7.1591 20.1399 8.13471C20.1878 9.18891 20.1983 9.50518 20.1983 12.1752C20.1983 14.8452 20.1878 15.1614 20.1399 16.2156C20.0948 17.1912 19.9319 17.7202 19.7948 18.0729C19.6137 18.5396 19.3971 18.8722 19.0473 19.2229C18.6975 19.5727 18.364 19.7893 17.8973 19.9705C17.5456 20.1075 17.0156 20.2704 16.0409 20.3145C14.9858 20.3624 14.6705 20.373 11.9996 20.373C9.32957 20.373 9.01329 20.3624 7.9591 20.3145C6.98444 20.2704 6.45448 20.1075 6.10181 19.9705C5.63509 19.7893 5.30251 19.5727 4.95271 19.2229C4.60195 18.8722 4.38536 18.5396 4.20423 18.0729C4.06718 17.7202 3.90428 17.1912 3.86019 16.2156C3.81227 15.1614 3.80174 14.8452 3.80174 12.1752C3.80174 9.50518 3.81227 9.18891 3.86019 8.13471C3.90428 7.1591 4.06718 6.6301 4.20423 6.27743C4.38536 5.8107 4.60195 5.4772 4.95271 5.12739C5.30251 4.77759 5.63509 4.561 6.10181 4.37987C6.45448 4.24282 6.98444 4.07989 7.9591 4.03485C9.01329 3.98693 9.32957 3.9764 11.9996 3.9764Z"
                                  fill="#464654"
                                />
                                <path
                                  d="M11.9996 15.5085C10.1586 15.5085 8.66638 14.0163 8.66638 12.1753C8.66638 10.3343 10.1586 8.84212 11.9996 8.84212C13.8406 8.84212 15.3327 10.3343 15.3327 12.1753C15.3327 14.0163 13.8406 15.5085 11.9996 15.5085ZM11.9996 7.0404C9.16379 7.0404 6.86468 9.33952 6.86468 12.1753C6.86468 15.0111 9.16379 17.3102 11.9996 17.3102C14.8363 17.3102 17.1344 15.0111 17.1344 12.1753C17.1344 9.33952 14.8363 7.0404 11.9996 7.0404Z"
                                  fill="#464654"
                                />
                                <path
                                  d="M18.5375 6.8372C18.5375 7.49942 18.0008 8.03707 17.3377 8.03707C16.6754 8.03707 16.1378 7.49942 16.1378 6.8372C16.1378 6.17401 16.6754 5.63733 17.3377 5.63733C18.0008 5.63733 18.5375 6.17401 18.5375 6.8372Z"
                                  fill="#464654"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>Instagram</span>
                            </NavDropdown.Item>
                          </>
                        )}
                        {utils.lng('url-facebook', '') && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href={utils.lng('url-facebook', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.26953 22H13.6315V11.9148H16.6761L17 8.5383H13.6315C13.6315 8.5383 13.6315 7.27774 13.6315 6.61531C13.6315 5.81899 13.8048 5.50429 14.6391 5.50429C15.3096 5.50429 17 5.50429 17 5.50429V2C17 2 14.5111 2 13.979 2C10.7329 2 9.26953 3.31966 9.26953 5.84596C9.26953 8.04625 9.26953 8.5383 9.26953 8.5383H7V11.9574H9.26953V22Z"
                                  fill="#464654"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>Facebook</span>
                            </NavDropdown.Item>
                          </>
                        )}
                        {utils.lng('url-youtube', '') && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href={utils.lng('url-youtube', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M18.1572 5.5C19.7566 5.5 21.1863 6.5964 21.4248 8.22852C21.5946 9.39055 21.75 10.8917 21.75 12.5C21.75 14.1083 21.5946 15.6095 21.4248 16.7715C21.1863 18.4036 19.7566 19.5 18.1572 19.5H5.5791C4.12611 19.5 2.78513 18.5715 2.55469 17.0488C2.39171 15.9719 2.25 14.4689 2.25 12.5C2.25 10.5311 2.39171 9.02814 2.55469 7.95117C2.78513 6.42847 4.12611 5.5 5.5791 5.5H18.1572ZM11 9.90234C10.6667 9.70989 10.25 9.95006 10.25 10.335V14.665C10.25 15.0499 10.6667 15.2901 11 15.0977L14.75 12.9326C15.0831 12.7401 15.0831 12.2599 14.75 12.0674L11 9.90234Z"
                                  fill="#464654"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>YouTubee</span>
                            </NavDropdown.Item>
                          </>
                        )}
                        {utils.lng('url-website', '') && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href={utils.lng('url-website', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3625 2 11.9875C2 10.6125 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6375 2 12.0125 2C13.3875 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6125 22 11.9875C22 13.3625 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3875 22 12.0125 22C10.6375 22 9.34167 21.7375 8.125 21.2125ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
                                  fill="#59596A"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>Website</span>
                            </NavDropdown.Item>
                          </>
                        )}
                      </NavDropdown>
                    )}
                  <span className="ui-icone-notificacoes ui-not">
                    <a href="/notificacoes">
                      {totalNotificacao > 0 && (
                        <span className="ui-notificacoes-total ui-not-total">{totalNotificacao}</span>
                      )}
                      <i className="fa fa-bell"></i>
                    </a>
                  </span>
                  {user.exibir_carrinho && (
                    <span id="quantidade_carrinho" className="ui-icone-carrinho ui-not">
                      <a href="/carrinho/pedido">
                        {pedido.quantidade > 0 && (
                          <span className="ui-carrinho-total ui-not-total">{pedido.quantidade}</span>
                        )}
                        <i className="fa fa-shopping-cart"></i>
                      </a>
                    </span>
                  )}
                  <div className="navbar-menu-p-right">
                    {/* <NavClients />
                    <NavIdioma /> */}
                    <NavDropdown
                      title={
                        <div className="pull-left">
                          {user.avatar && <img className="avatar" src={user.avatar} alt="user pic" />}
                          {!user.avatar && mobile && <i class="avatar fa fa-user"></i>}
                          {!mobile && (
                            <span id="username_usuario_logado" className="user-name">
                              <span id="username_usuario_logado" className="user-name">
                                {user.login}
                              </span>
                            </span>
                          )}
                        </div>
                      }
                      id="basic-nav-dropdown"
                      className="dropdown-menu-right"
                    >
                      <NavDropdown.Item style={{ marginBottom: '-10px' }} className="ui-nav-user-info-nome">
                        {' '}
                        {user.nome}{' '}
                      </NavDropdown.Item>
                      <NavDropdown.Item className="ui-nav-user-info-email"> {user.email} </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/meus_dados">
                        {' '}
                        <i className="fa fa-user ui-nav-icon-v2"></i> {utils.lng('meus_dados', 'Meus dados')}
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href="/alterar_senha">
                        <i className="fa fa-key ui-nav-icon-v2"></i> {utils.lng('msg_alterar_senha', 'Alterar senha')}
                      </NavDropdown.Item>
                      {user.tipo == 'ADMINISTRATIVO' && (
                        <>
                          <NavDropdown.Item href="#" onClick={changeFilial}>
                            <i style={{ paddingRight: '3px' }} className="fa fa-building ui-nav-icon-v2"></i>{' '}
                            {utils.lng('msg_alterar_filial', 'Alterar filial')}
                          </NavDropdown.Item>
                        </>
                      )}

                      <NavDropdown.Divider />
                      <NavClientsV2 className={clients.length <= 1 ? 'ui-nav-client-hidden' : ''} />
                      <NavDropdown.Divider className={clients.length <= 1 ? 'ui-nav-client-hidden' : ''} />
                      <NavIdiomaV2 />
                      <NavDropdown.Divider />

                      <NavDropdown.Item href="#" onClick={logout} style={{ color: 'red' }}>
                        <i className="fas fa-sign-out-alt ui-nav-icon-v2"></i> {utils.lng('sair', 'Sair')}
                      </NavDropdown.Item>
                    </NavDropdown>
                  </div>
                </div>
              )}

              {!mobile && (
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="mr-auto">
                    {tabs && (
                      <>
                        {tabs.map((i) => (
                          <>
                            {i.visible !== false && (
                              <Nav.Link
                                className={i.key === tab.key ? 'tab-item ui-tab-sel' : 'tab-item'}
                                key={'tab-' + i.key}
                                href="#"
                              >
                                <span
                                  className="tab-item-click"
                                  onClick={() => {
                                    onClick(i);
                                  }}
                                >
                                  {i.icon && <i className={i.icon + ' ui-tab-icon'}></i>}
                                  {i.label && <span className="tab-label">{label(i.label)}</span>}
                                </span>
                                <span
                                  onClick={() => {
                                    close(i);
                                  }}
                                  className="tab-close"
                                >
                                  <i className="fa fa-times"></i>
                                </span>
                              </Nav.Link>
                            )}
                          </>
                        ))}
                      </>
                    )}
                  </Nav>
                  <NavClientsSimple />

                  {(utils.lng('url-instagram', '') ||
                    utils.lng('url-facebook', '') ||
                    utils.lng('url-youtube', '') ||
                    utils.lng('url-website', '')) && (
                      <NavDropdown
                        id="social-midia-nav-dropdown"
                        title={
                          <svg
                            width="24"
                            style={{ marginBottom: 4 }}
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3625 2 11.9875C2 10.6125 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6375 2 12.0125 2C13.3875 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6125 22 11.9875C22 13.3625 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3875 22 12.0125 22C10.6375 22 9.34167 21.7375 8.125 21.2125ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
                              fill="#0a4c96"
                            />
                          </svg>
                        }
                      >
                        {utils.lng('url-instagram', '') && (
                          <NavDropdown.Item href={utils.lng('url-instagram', '')} target="_blank">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.9996 2.17468C9.28356 2.17468 8.94335 2.18617 7.87669 2.23505C6.81195 2.28392 6.08551 2.45261 5.44916 2.69986C4.79172 2.95574 4.23396 3.29788 3.67811 3.85373C3.12226 4.40958 2.7801 4.96734 2.52518 5.62478C2.27792 6.26113 2.10833 6.98757 2.06041 8.05231C2.01154 9.11896 2 9.45918 2 12.1752C2 14.8912 2.01154 15.2314 2.06041 16.298C2.10833 17.3628 2.27792 18.0892 2.52518 18.7255C2.7801 19.383 3.12226 19.9407 3.67811 20.4966C4.23396 21.0524 4.79172 21.3946 5.44916 21.6505C6.08551 21.8968 6.81195 22.0664 7.87669 22.1153C8.94335 22.1632 9.28356 22.1747 11.9996 22.1747C14.7155 22.1747 15.0558 22.1632 16.1224 22.1153C17.1872 22.0664 17.9136 21.8968 18.5499 21.6505C19.2073 21.3946 19.7651 21.0524 20.321 20.4966C20.8768 19.9407 21.2189 19.383 21.4748 18.7255C21.7221 18.0892 21.8908 17.3628 21.9396 16.298C21.9885 15.2314 22 14.8912 22 12.1752C22 9.45918 21.9885 9.11896 21.9396 8.05231C21.8908 6.98757 21.7221 6.26113 21.4748 5.62478C21.2189 4.96734 20.8768 4.40958 20.321 3.85373C19.7651 3.29788 19.2073 2.95574 18.5499 2.69986C17.9136 2.45261 17.1872 2.28392 16.1224 2.23505C15.0558 2.18617 14.7155 2.17468 11.9996 2.17468ZM11.9996 3.9764C14.6705 3.9764 14.9858 3.98693 16.0409 4.03485C17.0156 4.07989 17.5456 4.24282 17.8973 4.37987C18.364 4.561 18.6975 4.77759 19.0473 5.12739C19.3971 5.4772 19.6137 5.8107 19.7948 6.27743C19.9319 6.6301 20.0948 7.1591 20.1399 8.13471C20.1878 9.18891 20.1983 9.50518 20.1983 12.1752C20.1983 14.8452 20.1878 15.1614 20.1399 16.2156C20.0948 17.1912 19.9319 17.7202 19.7948 18.0729C19.6137 18.5396 19.3971 18.8722 19.0473 19.2229C18.6975 19.5727 18.364 19.7893 17.8973 19.9705C17.5456 20.1075 17.0156 20.2704 16.0409 20.3145C14.9858 20.3624 14.6705 20.373 11.9996 20.373C9.32957 20.373 9.01329 20.3624 7.9591 20.3145C6.98444 20.2704 6.45448 20.1075 6.10181 19.9705C5.63509 19.7893 5.30251 19.5727 4.95271 19.2229C4.60195 18.8722 4.38536 18.5396 4.20423 18.0729C4.06718 17.7202 3.90428 17.1912 3.86019 16.2156C3.81227 15.1614 3.80174 14.8452 3.80174 12.1752C3.80174 9.50518 3.81227 9.18891 3.86019 8.13471C3.90428 7.1591 4.06718 6.6301 4.20423 6.27743C4.38536 5.8107 4.60195 5.4772 4.95271 5.12739C5.30251 4.77759 5.63509 4.561 6.10181 4.37987C6.45448 4.24282 6.98444 4.07989 7.9591 4.03485C9.01329 3.98693 9.32957 3.9764 11.9996 3.9764Z"
                                fill="#464654"
                              />
                              <path
                                d="M11.9996 15.5085C10.1586 15.5085 8.66638 14.0163 8.66638 12.1753C8.66638 10.3343 10.1586 8.84212 11.9996 8.84212C13.8406 8.84212 15.3327 10.3343 15.3327 12.1753C15.3327 14.0163 13.8406 15.5085 11.9996 15.5085ZM11.9996 7.0404C9.16379 7.0404 6.86468 9.33952 6.86468 12.1753C6.86468 15.0111 9.16379 17.3102 11.9996 17.3102C14.8363 17.3102 17.1344 15.0111 17.1344 12.1753C17.1344 9.33952 14.8363 7.0404 11.9996 7.0404Z"
                                fill="#464654"
                              />
                              <path
                                d="M18.5375 6.8372C18.5375 7.49942 18.0008 8.03707 17.3377 8.03707C16.6754 8.03707 16.1378 7.49942 16.1378 6.8372C16.1378 6.17401 16.6754 5.63733 17.3377 5.63733C18.0008 5.63733 18.5375 6.17401 18.5375 6.8372Z"
                                fill="#464654"
                              />
                            </svg>
                            <span style={{ marginLeft: '10px' }}>Instagram</span>
                          </NavDropdown.Item>
                        )}
                        {utils.lng('url-facebook', '') && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href={utils.lng('url-facebook', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.26953 22H13.6315V11.9148H16.6761L17 8.5383H13.6315C13.6315 8.5383 13.6315 7.27774 13.6315 6.61531C13.6315 5.81899 13.8048 5.50429 14.6391 5.50429C15.3096 5.50429 17 5.50429 17 5.50429V2C17 2 14.5111 2 13.979 2C10.7329 2 9.26953 3.31966 9.26953 5.84596C9.26953 8.04625 9.26953 8.5383 9.26953 8.5383H7V11.9574H9.26953V22Z"
                                  fill="#464654"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>Facebook</span>
                            </NavDropdown.Item>
                          </>
                        )}
                        {utils.lng('url-youtube', '') && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href={utils.lng('url-youtube', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M18.1572 5.5C19.7566 5.5 21.1863 6.5964 21.4248 8.22852C21.5946 9.39055 21.75 10.8917 21.75 12.5C21.75 14.1083 21.5946 15.6095 21.4248 16.7715C21.1863 18.4036 19.7566 19.5 18.1572 19.5H5.5791C4.12611 19.5 2.78513 18.5715 2.55469 17.0488C2.39171 15.9719 2.25 14.4689 2.25 12.5C2.25 10.5311 2.39171 9.02814 2.55469 7.95117C2.78513 6.42847 4.12611 5.5 5.5791 5.5H18.1572ZM11 9.90234C10.6667 9.70989 10.25 9.95006 10.25 10.335V14.665C10.25 15.0499 10.6667 15.2901 11 15.0977L14.75 12.9326C15.0831 12.7401 15.0831 12.2599 14.75 12.0674L11 9.90234Z"
                                  fill="#464654"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>YouTube</span>
                            </NavDropdown.Item>
                          </>
                        )}
                        {utils.lng('url-website', '') && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href={utils.lng('url-website', '')} target="_blank">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3625 2 11.9875C2 10.6125 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6375 2 12.0125 2C13.3875 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6125 22 11.9875C22 13.3625 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3875 22 12.0125 22C10.6375 22 9.34167 21.7375 8.125 21.2125ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
                                  fill="#59596A"
                                />
                              </svg>
                              <span style={{ marginLeft: '10px' }}>Website</span>
                            </NavDropdown.Item>
                          </>
                        )}
                      </NavDropdown>
                    )}

                  <span className="ui-icone-faq ui-not" title={utils.lng('faq_atalho', 'Faq')}>
                    <a href="/faq">
                      <i class="fa fa-question-circle" style={{ fontSize: 20 }}></i>
                    </a>
                  </span>

                  {user.status_penn != 'INATIVO' && (
                    <span className="ui-icone-notificacoes ui-not">
                      <a href="/carrinho/favoritos">
                        <i className="fa fa-heart"></i>
                      </a>
                    </span>
                  )}
                  {user.status_penn != 'INATIVO' && (
                    <span className="ui-icone-notificacoes ui-not">
                      <a href="/notificacoes">
                        {totalNotificacao > 0 && (
                          <span className="ui-notificacoes-total ui-not-total">{totalNotificacao}</span>
                        )}
                        <i className="fa fa-bell"></i>
                      </a>
                    </span>
                  )}

                  {user.status_penn != 'INATIVO' && user.exibir_carrinho && (
                    <span id="quantidade_carrinho" className="ui-icone-carrinho ui-not">
                      <a href="/carrinho/pedido">
                        {pedido.quantidade > 0 && (
                          <span className="ui-carrinho-total ui-not-total">{pedido.quantidade}</span>
                        )}
                        <i className="fa fa-shopping-cart"></i>
                      </a>
                    </span>
                  )}
                  {/* <NavClients />
                  <NavIdioma /> */}
                  <NavDropdown
                    title={
                      <div className="pull-left">
                        {user.avatar && <img className="avatar" src={user.avatar} alt="user pic" />}
                        <span id="username_usuario_logado" className="user-name">
                          {user.login}
                        </span>
                      </div>
                    }
                    id="basic-nav-dropdown"
                    className="dropdown-menu-right"
                  >
                    <NavDropdown.Item style={{ marginBottom: '-10px' }} className="ui-nav-user-info-nome">
                      {' '}
                      {user.nome}{' '}
                    </NavDropdown.Item>
                    <NavDropdown.Item className="ui-nav-user-info-email"> {user.email} </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/meus_dados">
                      {' '}
                      <i className="fa fa-user ui-nav-icon-v2"></i> {utils.lng('meus_dados', 'Meus dados')}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/alterar_senha">
                      <i className="fa fa-key ui-nav-icon-v2"></i> {utils.lng('msg_alterar_senha', 'Alterar senha')}
                    </NavDropdown.Item>
                    {user.tipo == 'ADMINISTRATIVO' && (
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#" onClick={changeFilial}>
                          <i className="fa fa-building ui-nav-icon-v2"></i>{' '}
                          {utils.lng('msg_alterar_filial', 'Alterar filial')}
                        </NavDropdown.Item>
                      </>
                    )}
                    <NavDropdown.Divider />

                    <NavClientsV2 className={clients.length <= 1 ? 'ui-nav-client-hidden' : ''} />
                    <NavDropdown.Divider className={clients.length <= 1 ? 'ui-nav-client-hidden' : ''} />

                    <NavIdiomaV2 />
                    <NavDropdown.Divider />

                    <NavDropdown.Item href="#" onClick={fecharAbas}>
                      <i style={{ paddingRight: '7px' }} className="fa fa-times ui-nav-icon-v2"></i>{' '}
                      {utils.lng('fechar_abas', 'Fechar abas')}
                    </NavDropdown.Item>
                    <NavDropdown.Divider />

                    <NavDropdown.Item href="#" onClick={logout} style={{ color: 'red' }}>
                      <i className="fas fa-sign-out-alt ui-nav-icon-v2"></i> {utils.lng('sair', 'Sair')}
                    </NavDropdown.Item>
                  </NavDropdown>
                </Navbar.Collapse>
              )}
            </Navbar>
          </header>

          <Dialog
            open={showDialog}
            className="ui-dlg-escolha-filial"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <Element disabled={false} value={filialDialog} crud={crud} data={pedido} view={view}></Element>
            </DialogContent>
            <DialogActions>
              <Button
                id="btnFechar"
                onClick={() => {
                  closeDialog(true);
                }}
                variant="contained"
                color="secondary"
              >
                {utils.lng('fechar', 'Fechar')}
              </Button>
              <Button id="btnConfirmarFilial" onClick={confirmDialogFilial} variant="outlined" color="primary">
                {utils.lng('confirmar', 'Confirmar')}
              </Button>
            </DialogActions>
          </Dialog>

          <div className={menuClass}>
            <a href={user.url} className="logo-menu-a">
              <img
                className="z-100"
                src="https://storage.googleapis.com/interpennweb-storage/email/images/logon_fundo_branco_vermelha.png"
              ></img>
              {/* <img src="/static/img/logo_menu.png" ></img> */}
            </a>
            <Element crud={crud} view={view} value={lateral} user={user}></Element>
          </div>
        </>
      )}
      <section className={props.full ? 'view-data ui-view-full' : 'view-data'}>
        {
          <>
            {!mobile && (
              <>
                {filialEdit && labelFilial() && (
                  <span className="user-filial user-filial-hv" onClick={confirmDialog}>
                    {labelFilial()}
                  </span>
                )}

                {!filialEdit && labelFilial() && <span className="user-filial">{labelFilial()}</span>}
              </>
            )}
          </>
        }
        <Dialog className="ui-dialog-loading" open={loading}>
          <DialogContent>
            <div className="ui-view-loading-data">
              <i className="fas fas fa-circle-notch fa-spin"></i>
            </div>
          </DialogContent>
        </Dialog>
        {(processo.id_processo > 0 || processo.admin || processo.skip) && (
          <div
            className={'ui-view ui-view-' + (name ? name : tab.name) + ' ' + (props.className ? props.className : '')}
          >
            {props.children}
          </div>
        )}
      </section>
      {exibirMsgCookie && !props.public && (
        <div className="ui-cookie-bar">
          <Element crud={crud} view={view} value={cookie} user={user}></Element>
        </div>
      )}
      {popup && (
        <>
          {ispopup && popup.imagem && (
            <div className="ui-pop-up-geral">
              <div
                className="ui-pop-up-fundo"
                onClick={() => {
                  setispopup(false);
                }}
              ></div>
              <div className="ui-pop-up">
                <div>
                  <IconButton
                    aria-label="close"
                    className="close"
                    onClick={() => {
                      setispopup(false);
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Button
                    className="ui-pop-up-button"
                    onClick={() => {
                      window.location.href = popup.link_redirecionamento;
                    }}
                  >
                    <img src={popup.imagem} />
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default View;
